import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'ga/:callback',
  async getComponent (nextState) {
    const {
      default: GaContainer
    } = await import(/* webpackChunkName: "ga" */ './containers/GaContainer.jsx')
      .catch(handleChunkLoadError);
    return GaContainer;
  }
});
